<script>
  import BookList from './BookList.svelte';
  import SearchBar from './SearchBar.svelte';
  import { user, book_lists, genres } from './stores.js';

  export let term;


  import { afterUpdate } from "svelte";

  afterUpdate(() => {
    window.scrollTo(0, 0);
  });
</script>

<style>
  main {
    padding: 50px 60px;
  }

  .sorters {
    text-align: right;
  }

  .sort {
    display: inline-block;
    padding: 5px 10px;
    font-weight: 600;
    font-size: 14px;

  }
  .sort.active {
    padding: 5px 20px;
    color: #FFF;
    background: #ec6a33;
    border-radius: 5px;
    margin-left: 10px;
  }
</style>

<main>
  <h1>Results for '{term}'</h1>

  <SearchBar term={term} />

  <BookList books={book_lists.recommended} />
</main>
